import { outbrainMixins } from './outbrainPlacementWidgets'
import { styleMixins } from '../../common/ad_ops/styleMixins'
import type { AdPlacement } from '@duplex/common/ad_ops/adPlacementMappings'
import { getNTPTaboolaWidgetForPlacement } from '@duplex/common/ad_ops/taboolaPlacementUtil'
import { taboolaMixins } from './taboolaPlacementWidgets'

export const placementConfigs: Record<string, AdPlacement> = {
  // Section placements
  sectiontab_300x250: {
    outbrain: { ...outbrainMixins.AR_62 },
    style: { ...styleMixins[304_300] },
    taboola: getNTPTaboolaWidgetForPlacement('sectiontab-300x250'),
    assertive: { refresh: true },
    props: {},
  },

  sectiontab_slider: {
    outbrain: {
      ...outbrainMixins.AR_63,
    },
    style: {
      ...styleMixins[304_612],
    },
    taboola: {},
    assertive: {},
    props: {
      lazyRender: true,
    },
  },
  // Homepage placements
  newtab_r1_c2: {
    outbrain: {
      ...outbrainMixins.AR_35,
    },
    style: {
      ...styleMixins[304_300],
    },
    taboola: getNTPTaboolaWidgetForPlacement('r1-c2'),
    assertive: { refresh: true },
    props: {
      lazyRender: true,
    },
  },
  newtab_r1_topright: {
    outbrain: {
      ...outbrainMixins.AR_36,
    },
    style: {
      ...styleMixins[304_300],
    },
    taboola: getNTPTaboolaWidgetForPlacement('r1-topright'),
    assertive: { refresh: true },
    props: {
      lazyRender: true,
    },
  },
  newtab_r2_c1: {
    outbrain: {
      ...outbrainMixins.AR_37,
    },
    style: {
      ...styleMixins[304_300],
    },
    taboola: getNTPTaboolaWidgetForPlacement('r2-c1'),
    assertive: { refresh: true },
    props: {
      lazyRender: true,
    },
  },
  newtab_r3_right: {
    outbrain: {
      ...outbrainMixins.AR_45,
    },
    style: {
      ...styleMixins[304_300],
    },
    taboola: getNTPTaboolaWidgetForPlacement('r3-right'),
    assertive: { refresh: true },
    props: {
      lazyRender: true,
    },
  },
  newtab_r4_c1: {
    outbrain: {
      ...outbrainMixins.AR_57,
    },
    style: {
      ...styleMixins[304_300],
    },
    taboola: getNTPTaboolaWidgetForPlacement('r4-c1'),
    assertive: { refresh: true },
    props: {
      lazyRender: true,
    },
  },
  newtab_r4_right: {
    outbrain: {
      ...outbrainMixins.AR_58,
    },
    style: {
      ...styleMixins[304_300],
    },
    taboola: getNTPTaboolaWidgetForPlacement('r4-right'),
    assertive: { refresh: true },
    props: {
      lazyRender: true,
    },
  },
  newtab_r3_c1: {
    outbrain: {
      ...outbrainMixins.AR_38,
    },
    style: {
      ...styleMixins[304_300],
    },
    taboola: getNTPTaboolaWidgetForPlacement('r3-c1'),
    assertive: { refresh: true },
    props: {
      lazyRender: true,
    },
  },
  newtab_r2_c4: {
    outbrain: {
      ...outbrainMixins.AR_38,
    },
    style: {
      ...styleMixins[304_300],
    },
    taboola: getNTPTaboolaWidgetForPlacement('r2-c4'),
    assertive: { refresh: true },
    props: {
      lazyRender: true,
    },
  },
  newtab_endless_right: {
    outbrain: {
      ...outbrainMixins.AR_38,
    },
    style: {
      ...styleMixins[304_300],
    },
    taboola: getNTPTaboolaWidgetForPlacement('endless'),
    assertive: { refresh: true },
    props: {
      lazyRender: true,
    },
  },
  newtab_slider_1: {
    outbrain: {
      ...outbrainMixins.AR_27,
    },
    style: {
      ...styleMixins[304_612],
    },
    taboola: {},
    assertive: {},
    // Primis "Discovery_Onenews_Tile"
    primis: {
      siteId: '122789',
      playerApiId: 'onenews_homepage',
    },
    props: {
      lazyRender: true,
    },
  },
  newtab_slider_2: {
    outbrain: {
      ...outbrainMixins.AR_27,
    },
    style: {
      ...styleMixins[304_612],
    },
    taboola: {},
    assertive: {},
    props: {
      lazyRender: true,
    },
  },
  newtab_slider_3: {
    outbrain: {
      ...outbrainMixins.AR_27,
    },
    style: {
      ...styleMixins[304_612],
    },
    taboola: {},
    assertive: {},
    props: {
      lazyRender: true,
    },
  },
  newtab_slider_4: {
    outbrain: {
      ...outbrainMixins.AR_27,
    },
    style: {
      ...styleMixins[304_612],
    },
    taboola: {},
    assertive: {},
    props: {
      lazyRender: true,
    },
  },
  newtab_leaderboard: {
    outbrain: {
      ...outbrainMixins.AR_59,
    },
    taboola: {},
    assertive: { refresh: true },
    style: {
      ...styleMixins['400_FULL'],
    },
    props: {
      lazyRender: true,
    },
  },
  newtab_leaderboard_mb: {
    outbrain: {
      ...outbrainMixins.AR_4,
    },
    taboola: {},
    assertive: { refresh: true },
    style: {
      ...styleMixins[100_300],
    },
    props: {
      lazyRender: true,
    },
  },
  newtab_970x250: {
    outbrain: {},
    style: {
      ...styleMixins['250_970'],
    },
    taboola: {},
    assertive: { refresh: true },
    props: {
      lazyRender: false,
    },
  },
  newtab_hero_dk: {
    outbrain: {
      ...outbrainMixins.AR_59,
    },
    style: {
      ...styleMixins['250_970'],
    },
    taboola: {},
    assertive: { refresh: true },
    props: {
      lazyRender: false,
    },
  },
  newtab_hero_tb: {
    outbrain: {
      ...outbrainMixins.AR_59,
    },
    style: {
      ...styleMixins['90_728'],
    },
    taboola: {},
    assertive: { refresh: true },
    props: {
      lazyRender: false,
    },
  },
  newtab_hero_mb: {
    outbrain: {
      ...outbrainMixins.AR_4,
    },
    style: {
      ...styleMixins['50_300'],
    },
    taboola: {},
    assertive: {},
    props: {
      lazyRender: false,
    },
  },

  // Article page placements
  article_hero: {
    outbrain: {
      ...outbrainMixins.AR_7,
    },
    taboola: {},
    assertive: {},
    style: {
      ...styleMixins['310_FULL'],
    },
    props: {
      sticky: true,
    },
  },
  article_hero_mb: {
    outbrain: {
      ...outbrainMixins.AR_60,
    },
    taboola: {},
    assertive: {},
    style: {
      ...styleMixins[100_300],
    },
    props: {
      sticky: true,
    },
  },
  article_content_below_button: {
    outbrain: {
      ...outbrainMixins.AR_31,
    },
    taboola: {
      ...taboolaMixins.article_content_below_button,
    },
    assertive: {},
    style: {
      ...styleMixins.auto,
    },
    props: {
      isFeed: true,
    },
  },
  article_content_middle: {
    outbrain: {
      ...outbrainMixins.AR_9,
    },
    taboola: {},
    assertive: {},
    style: {
      ...styleMixins['400_FULL'],
    },
    props: {},
  },
  article_content_middle_mb: {
    outbrain: {
      ...outbrainMixins.AR_61,
    },
    taboola: {},
    assertive: {},
    style: {
      ...styleMixins['310_FULL'],
    },
    props: {
      lazyRender: true,
    },
  },
  article_siderail_top: {
    outbrain: {
      ...outbrainMixins.AR_51,
    },
    taboola: {},
    assertive: {},
    style: {
      ...styleMixins[290_340],
    },
    props: {},
  },
  article_siderail_middle: {
    outbrain: {
      ...outbrainMixins.AR_52,
    },
    taboola: {
      // ...taboolaMixins.article_siderail_middle,
    },
    assertive: {},
    style: {
      ...styleMixins[290_340],
    },
    props: {},
  },
  article_siderail_bottom: {
    outbrain: {
      ...outbrainMixins.AR_53,
    },
    taboola: {},
    assertive: {},
    style: {
      ...styleMixins[610_300],
    },
    props: {},
  },
  article_content_top: {
    outbrain: {
      ...outbrainMixins.AR_54,
    },
    taboola: {},
    assertive: {},
    style: {},
    props: {},
  },
  article_content_below_image: {
    outbrain: {
      ...outbrainMixins.AR_55,
    },
    taboola: {},
    assertive: {},
    style: {},
    props: {},
  },
  article_content_above_button: {
    outbrain: {
      ...outbrainMixins.AR_56,
    },
    taboola: {},
    assertive: {},
    style: {},
    props: {},
  },
  // Article stream: replaces the rec grid's cards and native slots with one
  // Outbrain feed widget. Auto sizing because the feed grows with its own rows;
  // isFeed switches the click handler to per-tile feed positions.
  article_rec_feed: {
    outbrain: {
      ...outbrainMixins.AR_2,
    },
    taboola: {},
    assertive: {},
    style: {
      ...styleMixins.auto,
    },
    props: {
      isFeed: true,
      lazyRender: true,
    },
  },
}
